import styled, { css } from 'styled-components'
import SPACES from '@web-ui-kit/spaces'
import Text from '@web-ui-kit/text'
import { SnackbarSizes } from './snackbar'

type color = {
  $color: string
}

type size = {
  $size: SnackbarSizes
}

export const Container = styled.div<color & size>`
  align-items: center;
  box-sizing: border-box;
  background-color: ${({ $color }) => $color};
  display: flex;
  gap: ${SPACES.XS};
  padding: ${SPACES.S};
  width: ${({ $size }) => ($size === 'small' ? '25.3125rem' : '42.1875rem')};
  max-width: 100%;
  ${({ $size }) =>
    $size === 'large' &&
    css`
      border-radius: 0.625rem;
    `}
`

export const CustomText = styled(Text)<color>`
  color: ${({ $color }) => $color};
  flex: 1;
  margin: 0;
`
